import { render, staticRenderFns } from "./UiShowWithdrawList.vue?vue&type=template&id=74bd4e5e&lang=pug&"
import script from "./UiShowWithdrawList.vue?vue&type=script&lang=js&"
export * from "./UiShowWithdrawList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports